import { Box, Flex, Img, Link, Text } from '@chakra-ui/react'
import React from 'react'
import {motion} from 'framer-motion'
export const Footer = () => {
  return (
    <>
    <motion.div  initial={{ opacity: 0 }}
    whileInView={{ opacity: 1,transition:{duration: 1}}}> 
    <Flex name='Contact' direction={'column'} margin='3rem 0rem'>
    <Box width={{xs:'250px',sm:'320px',xl:'600px'}} textAlign={'center'} margin={'2rem auto'} padding={'0.5rem'} borderBottom={'1px solid black'}>
        <Text fontSize={{xs:'1rem',md:'1.5rem',lg:'2rem'}} fontWeight={'900'} as={'h2'} color={'#000'}>
        Si te gustó lo que leiste hasta acá,me podés
        contactar a través de: 
        </Text>
    </Box>
        <Box margin={'1rem auto'} display={'flex'}>
            <Link href='https://www.linkedin.com/in/lara-flores/' isExternal >
            <Img width={'1rem'} height={'1rem'} margin={'0rem 0.5rem'} src={'/assets/linkedin-brands.svg'}/>
            </Link>
            <Link href='https://wa.me/3329607961' isExternal>
            <Img width={'1rem'} height={'1rem'} margin={'0rem 0.5rem'} src={'/assets/whatsapp-brands.svg'}/>
            </Link>
            <Link href='mailto:laraflores.community@gmail.com' isExternal>
            <Img width={'1rem'} height={'1rem'} margin={'0rem 0.5rem'} src={'/assets/envelope-regular.svg'}/>
            </Link>
            <Link href='https://www.facebook.com/profile.php?id=100083237025725' isExternal>
            <Img width={'1rem'} height={'1rem'} margin={'0rem 0.5rem'} src={'/assets/facebook-f-brands.svg'}/>
            </Link>
            <Link href='https://www.instagram.com/laraaflores_/' isExternal>
            <Img width={'1rem'} height={'1rem'} margin={'0rem 0.5rem'} src={'/assets/instagram-brands.svg'}/>
            </Link>
        </Box>
        <Box margin={'auto'}>
          <Text>
            Creado por <Link href='https://github.com/t0uu' isExternal>Santiago Touzet</Link>
          </Text>
        </Box>
        
    </Flex>
    </motion.div>
    </>
  )
}
